import * as actionCreators from 'client/redux/settings/actionCreators';
import { SETTINGS_INDEX }  from 'client/redux/settings/constants';

export const settingsIndex = () => dispatch => {
  return dispatch(actionCreators.settingsIndex(SETTINGS_INDEX));
};
